import { render, staticRenderFns } from "./StudentAttendanceSlidebar.vue?vue&type=template&id=4f55e419"
import script from "./StudentAttendanceSlidebar.vue?vue&type=script&lang=js"
export * from "./StudentAttendanceSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports